<script setup lang="ts">
  import { useIslandTime } from '~renderer/composables/useIslandTime'
  import type { QueuedUserPublicView } from '~shared/types/island'

  const props = defineProps<{
    islandId: string
    visitors: QueuedUserPublicView[]
  }>()

  const emit = defineEmits<{
    refresh: []
    kick: [userId: string, visitId: string | null]
  }>()
  const { timeAgo } = useIslandTime()

  // MARK: Methods
  // remove user
  const onRemoveVisitorClicked = async (userId: string, visitId: string | null) => {
    emit('kick', userId, visitId)
  }
</script>

<template>
  <!-- Body Section -->
  <div v-if="visitors.length" class="mt-4 mb-1 flex min-h-0 flex-col items-center gap-4">
    <!-- Queue List -->
    <div class="lg:max-none relative max-h-30 w-full flex-1 space-y-2 overflow-y-auto">
      <div
        v-for="visitor in visitors"
        class="grid grid-cols-[1fr_minmax(5rem,auto)_3rem] items-center gap-2"
      >
        <div class="truncate">
          <span class="mr-1">
            <span v-if="visitor.claimedAt">🏝️</span>
            <span v-else="visitor.eligibleAt">✈️</span>
          </span>
          <span class="font-bold" :class="visitor.eligibleAt ? 'text-[#84723c]' : 'text-white'">{{
            visitor.name
          }}</span>
        </div>

        <div class="text-right">
          <span class="text-tan-400 ml-2 italic">{{ timeAgo(visitor.updatedAt) }}</span>
        </div>

        <div class="flex justify-end">
          <a
            class="cursor-pointer text-white/40 hover:text-white"
            target="_blank"
            :href="`/user/${visitor.userId}`"
          >
            <i-fa7-solid-arrow-up-right-from-square class="size-4" />
          </a>
          <button
            class="cursor-pointer text-white/40 hover:text-white"
            @click="onRemoveVisitorClicked(visitor.userId, visitor.visitId)"
          >
            <i-fa7-solid-x class="size-4" />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="text-md my-6 text-center italic">
    <p>There are currently no visitors on your island.</p>
  </div>
</template>
